import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Profiledropdown from "./profiledropdown";
import useAuth from "../hooks/useAuth"; // import the hook

function Header({ isSidebarOpen, setIsSidebarOpen, toggleSidebar }) {
  const loggedIn = useAuth();

  return (
    <Navbar className="header-navbar" data-bs-theme="light">
      <Container fluid>
        <Nav className="me-auto w-100 align-items-center">
          <div>
            <img src={"/images/LC-logo.svg"} className="img-fluid" alt="logo" />
          </div>
          <div className="ms-auto">
            {loggedIn && <Profiledropdown />} {/* Only show if logged in */}
          </div>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default Header;
